import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Stethoscope, CalendarDays } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { fetchLaundryById } from '@/pages/parametrizacion/laundries/Services/laundries.services';
import AusenciasPage from '@/pages/personal/ausencias/AusenciasPage';

/** Incapacidades y permisos del personal de un centro de lavado (gestión por centro). */
const AusenciasCentroPage = () => {
  const { idLavanderia } = useParams();
  const [centro, setCentro] = useState(null);

  useEffect(() => {
    fetchLaundryById(idLavanderia)
      .then((l) => setCentro({ id: idLavanderia, nombre: l?.nombre || 'Centro de lavado' }))
      .catch(() => setCentro({ id: idLavanderia, nombre: 'Centro de lavado' }));
  }, [idLavanderia]);

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="p-4">
      <Card>
        <CardHeader className="flex flex-col md:flex-row md:items-center gap-4 border-b border-border/50">
          <Button asChild variant="outline" className="w-fit">
            <Link to={`/centros-lavado/${idLavanderia}`}>
              <ArrowLeft className="mr-2 h-4 w-4" /> Volver
            </Link>
          </Button>
          <div className="flex items-center gap-3">
            <div className="bg-rose-500/15 p-2.5 rounded-lg">
              <Stethoscope className="h-6 w-6 text-rose-500 dark:text-rose-400" />
            </div>
            <div>
              <CardTitle className="text-xl">Incapacidades y permisos</CardTitle>
              <CardDescription>
                {centro?.nombre || 'Cargando…'} · se liquidan en la nómina por periodo
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          {!centro ? (
            <p className="text-sm text-muted-foreground">Cargando…</p>
          ) : (
            <Tabs defaultValue="incapacidad">
              <TabsList>
                <TabsTrigger value="incapacidad">
                  <Stethoscope className="mr-2 h-4 w-4" /> Incapacidades
                </TabsTrigger>
                <TabsTrigger value="permiso">
                  <CalendarDays className="mr-2 h-4 w-4" /> Permisos
                </TabsTrigger>
              </TabsList>
              <TabsContent value="incapacidad" className="mt-4">
                <AusenciasPage tipo="incapacidad" centro={centro} />
              </TabsContent>
              <TabsContent value="permiso" className="mt-4">
                <AusenciasPage tipo="permiso" centro={centro} />
              </TabsContent>
            </Tabs>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default AusenciasCentroPage;
